/**
 * 無限ループスライダー
 * @codex https://splidejs.com/extensions/auto-scroll/
 */

import "@splidejs/splide/dist/css/splide-core.min.css";
import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

const topMemberSplideElement = document.querySelector("#js-splide-loop-member");

if (topMemberSplideElement) {
  const topMemberSplideOptions = {
    arrows: false, // 矢印ボタンを非表示
    pagination: false, // ページネーションを非表示
    type: "loop", // ループさせる
    autoWidth: true, // cssで幅指定
    gap: "calc(18 / 16 * 1rem)", // スライド間の余白
    drag: true, // スマホで動作が不安定なので、実機確認必須
    autoScroll: {
      speed: 0.5, // スクロール速度
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // フォーカスが当たってもスクロールを停止させない
    },
    breakpoints: {
      768: {
        gap: "calc(9 / 16 * 1rem)", // スライド間の余白
      },
    },
  };
  const topMemberSplide = new Splide(
    topMemberSplideElement,
    topMemberSplideOptions
  );
  topMemberSplide.mount({ AutoScroll });
  // topMemberSplide.mount(); // デバッグ用
}

const copySplideElement = document.querySelector("#js-splide-loop-copy");
if (copySplideElement) {
  const copySplideOptions = {
    arrows: false, // 矢印ボタンを非表示
    pagination: false, // ページネーションを非表示
    type: "loop", // ループさせる
    autoWidth: true, // cssで幅指定
    gap: "calc(18 / 16 * 1rem)", // スライド間の余白
    drag: true, // スマホで動作が不安定なので、実機確認必須
    autoScroll: {
      speed: -0.5, // スクロール速度
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // フォーカスが当たってもスクロールを停止させない
    },
    breakpoints: {
      768: {
        gap: "calc(9 / 16 * 1rem)", // スライド間の余白
      },
    },
  };
  const copySplide = new Splide(copySplideElement, copySplideOptions);
  copySplide.mount({ AutoScroll });
  // copySplide.mount(); // デバッグ用
}

